import React, {useEffect, useState} from 'react';
import {getInterpolatedColor, tag_palette} from "../color/Palettes";

export function TagGroupDisplay({tags}) {

    const [hasActivated, setActivated] = useState(false)
    const [counter, setCounter] = useState(-1);

    useEffect(() => {
        let interval = null;

        if (!hasActivated) {
            interval = setInterval(() => {
                if(counter === tags.length-1) {
                    setActivated(true);
                }
                setCounter(counter + 1);
            }, 100);

        }

        //Clearing the interval
        return () => clearInterval(interval)
    }, [counter]);

    return (
        <div>
            {
                tags != null && tags.map((tag, idx) => (
                    <span className={"badge m-2 px-3 py-2 animate__animated animate__bounceIn "+(idx <= counter ? "" : "d-none")}
                          style={{backgroundColor: getInterpolatedColor(tag_palette, idx, 0, tags.length)}}>
                                                                    {tag.text}
                    </span>
                ))
            }
        </div>
    );

}